// frontend/src/visitor_ai/components/VisitorReportTable.jsx
import React from "react";

/**
 * VisitorReportTable
 * props:
 *  - rows: array of objects
 *  - columns: optional array describing columns: [{ key, label }]
 *  - onRowAction: function(actionSchema) called when row action clicked
 */

const VisitorReportTable = ({ rows = [], columns = null, onRowAction = () => {} }) => {
  if (!rows || rows.length === 0) return <p className="visitor-ai-no-data">No data found.</p>;

  // derive columns if not provided
  const cols = columns && columns.length > 0 ? columns : Object.keys(rows[0]).map(k => ({ key: k, label: k }));

  return (
    <div className="visitor-ai-table-wrapper">
      <table className="visitor-ai-report-table">
        <thead>
          <tr>
            {cols.map(col => <th key={col.key}>{col.label || col.key}</th>)}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, idx) => (
            <tr key={idx}>
              {cols.map(col => (
                <td key={col.key}>
                  {renderCell(r[col.key], col)}
                </td>
              ))}
              <td>
                {/* if row contains an action_schema, render action button(s) */}
                {r.action_schema ? (
                  <button className="visitor-ai-row-action" onClick={() => onRowAction(r.action_schema)}>
                    {r.action_schema.label || r.action_schema.action_type || "Action"}
                  </button>
                ) : (
                  <em>No actions</em>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

function renderCell(value, col) {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

export default VisitorReportTable;
